import { SalesNavigatorFilterType } from './types';
import { COMPANY_HEADCOUNT_IDS, COMPANY_TYPE_IDS } from './companyIds';
import { YEARS_AT } from './dateIds';
import { REGION_IDS } from './geographyIds';
import { INDUSTRY_IDS } from './industry';
import { PROFILE_LANGUAGE_IDS } from './personaIds';
import { ROLE_FUNCTION_IDS, SENIORITY_LEVEL_IDS } from './roleIds';

export const initialFilters: SalesNavigatorFilterType[] = [
  {
    name: 'Current Company',
    path: 'currentCompany',
    filterType: 'multiSelectCreatable',
    criteria: []
  },
  {
    name: 'Past Company',
    path: 'pastCompany',
    filterType: 'multiSelectCreatable',
    criteria: []
  },
  {
    name: 'Company Type',
    path: 'companyType',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(COMPANY_TYPE_IDS),
    criteria: []
  },
  {
    name: 'Company Headcount',
    path: 'companyHeadcount',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(COMPANY_HEADCOUNT_IDS),
    criteria: []
  },
  {
    name: 'Company Headquarters Location',
    path: 'companyHeadquartersLocation',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(REGION_IDS),
    criteria: []
  },
  {
    name: 'Current Job Title',
    path: 'currentJobTitle',
    filterType: 'multiSelectCreatable',
    criteria: []
  },
  {
    name: 'Past Job Title',
    path: 'pastJobTitle',
    filterType: 'multiSelectCreatable',
    criteria: []
  },
  {
    name: 'Function',
    path: 'function',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(ROLE_FUNCTION_IDS),
    criteria: []
  },
  {
    name: 'Seniority Level',
    path: 'seniorityLevel',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(SENIORITY_LEVEL_IDS),
    criteria: []
  },
  {
    name: 'Years At Current Company',
    path: 'yearsAtCurrentCompany',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(YEARS_AT),
    criteria: []
  },
  {
    name: 'Years In Current Position',
    path: 'yearsInCurrentPosition',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(YEARS_AT),
    criteria: []
  },
  {
    name: 'Geography',
    path: 'geography',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(REGION_IDS),
    criteria: []
  },
  {
    name: 'Profile Language',
    path: 'profileLanguage',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(PROFILE_LANGUAGE_IDS),
    criteria: []
  },
  {
    name: 'Years Of Experience',
    path: 'yearsOfExperience',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(YEARS_AT),
    criteria: []
  },
  {
    name: 'Industry',
    path: 'industry',
    filterType: 'multiSelectFromOptions',
    options: Object.keys(INDUSTRY_IDS),
    criteria: []
  },
  {
    name: 'Groups',
    path: 'groups',
    filterType: 'multiSelectCreatable',
    criteria: []
  },
  {
    name: 'School',
    path: 'school',
    filterType: 'multiSelectCreatable',
    criteria: []
  }
];
